import { calculateFootprintingProgress, isPercentageComplete } from "utils";

import { FarmFootprintReturnBody, FootprintingFormCompletionStats } from "models";

export type HomeFootprintingSummary = {
  completionPercent: number;
  doneCount: number;
  totalCount: number;
  totalPayout: number;
  isSubmitted: boolean;
};

const EMPTY_SUMMARY: HomeFootprintingSummary = { completionPercent: 0, doneCount: 0, totalCount: 0, totalPayout: 0, isSubmitted: false };

/** The farm form plus the crop and livestock assessments that were picked (have a footprint), as the footprinting page counts them. */
export const summariseFootprinting = (
  farmProgress: FarmFootprintReturnBody | undefined | null,
  formStats: FootprintingFormCompletionStats[]
): HomeFootprintingSummary => {
  if (!farmProgress) return EMPTY_SUMMARY;

  const { completionRate, totalPayout, isSubmitted } = calculateFootprintingProgress(farmProgress, formStats);
  const allForms = [farmProgress, ...formStats.filter((form) => form.footprint !== undefined)];
  const doneForms = isSubmitted ? allForms : allForms.filter((form) => isPercentageComplete(form.completionPct || 0) || !!form.footprint?.isSubmitted);

  return {
    completionPercent: Math.round(completionRate * 100),
    doneCount: doneForms.length,
    totalCount: allForms.length,
    totalPayout,
    isSubmitted,
  };
};
